import _react, { forwardRef } from "react";
import { Flex } from "@react-spectrum/layout";
import { filterDOMProps } from "@react-aria/utils";
import { classNames, SlotProvider, useStyleProps } from "@react-spectrum/utils";
import _babelRuntimeHelpersEsmObjectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _babelRuntimeHelpersEsmExtends from "@babel/runtime/helpers/esm/extends";
import "./main.css";

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

// ASSET: /Users/govett/dev/react-spectrum-v3/node_modules/@adobe/spectrum-css-temp/components/illustratedmessage/vars.css
var $ad19f21617e510127aa82f891debc5e5$exports = {};
$ad19f21617e510127aa82f891debc5e5$exports = {
  "spectrum-IllustratedMessage": "_spectrum-IllustratedMessage_5a24b",
  "spectrum-IllustratedMessage-heading": "_spectrum-IllustratedMessage-heading_5a24b",
  "spectrum-IllustratedMessage-description": "_spectrum-IllustratedMessage-description_5a24b",
  "spectrum-IllustratedMessage--cta": "_spectrum-IllustratedMessage--cta_5a24b"
};
var $ad19f21617e510127aa82f891debc5e5$$interop$default = $parcel$interopDefault($ad19f21617e510127aa82f891debc5e5$exports);

function $b21bf6f0f2cbeeeaecfa01199fa925a1$var$IllustratedMessage(props, ref) {
  let {
    children
  } = props,
      otherProps = _babelRuntimeHelpersEsmObjectWithoutPropertiesLoose(props, ["children"]);

  let {
    styleProps
  } = useStyleProps(otherProps);
  let headingClassName = classNames($ad19f21617e510127aa82f891debc5e5$$interop$default, 'spectrum-IllustratedMessage-heading');
  let contentClassName = classNames($ad19f21617e510127aa82f891debc5e5$$interop$default, 'spectrum-IllustratedMessage-description');
  let slots = {
    heading: {
      UNSAFE_className: headingClassName
    },
    content: {
      UNSAFE_className: contentClassName
    }
  };
  return /*#__PURE__*/_react.createElement(Flex, _babelRuntimeHelpersEsmExtends({}, filterDOMProps(otherProps), {
    UNSAFE_style: styleProps.style,
    isHidden: styleProps.hidden,
    UNSAFE_className: classNames($ad19f21617e510127aa82f891debc5e5$$interop$default, 'spectrum-IllustratedMessage', styleProps.className),
    ref: ref
  }), /*#__PURE__*/_react.createElement(SlotProvider, {
    slots: slots
  }, children));
}
/**
 * An IllustratedMessage displays an illustration and a message, usually
 * for an empty state or an error page.
 */


export let IllustratedMessage = forwardRef($b21bf6f0f2cbeeeaecfa01199fa925a1$var$IllustratedMessage);
//# sourceMappingURL=module.js.map
